<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import AdminForm from '@/components/admin/AdminForm.vue'
import AdminEnseigneForm from '@/components/admin/enseigne/AdminEnseigneForm.vue'
import { AloDbEnseigne } from '@/models/alodb/AloDbEnseigne'
import { SecurityItemsKeys } from '@/enum/SecurityItems'

@Component({
  name: 'AdminEnseigne', 
  components: {AdminEnseigneForm},
  props:{
    itemid:{
      type:Number
    }
  }
})
export default class AdminEnseigne extends AdminForm<AloDbEnseigne> {  

  created() {                            
    if(!this.$store.myGetters.userSecurity[SecurityItemsKeys.ADMIN_COMPANY].enable) {
      this.canRender = false       
      this.$router.push('/')
    }     
  }
  
  get itemTypeName(){
    return "Enseigne"
  }

  get originalLibelle(){
    return this.original.ENS_LIBELLE
  }
}
</script>